import {
  THEME_TEMPLATE_API,
  THEME_TEMPLATE_API_SEARCH,
  THEME_TEMPLATE_API_REMOVE,
} from "shared/constants/api-endpoint";
import { RemovedEntityModel } from "shared/models/removed-entity-model";
import { apiClient } from "shared/plugins/http-service";
import { PagedResult } from "states/paged-result-model";
import {
  SearchThemeTemplateRequestModel,
  ThemeTemplateModel,
} from "./theme-template.models";

export const searchThemeTemplate = async (
  searchThemeTemplateRequestModel: SearchThemeTemplateRequestModel
) => {
  const createResponse = await apiClient.postHttp<
    PagedResult<ThemeTemplateModel>
  >(`${THEME_TEMPLATE_API_SEARCH}`, searchThemeTemplateRequestModel);
  return createResponse;
};

export const removeThemeTemplate = async (
  removedModel: RemovedEntityModel<string>
) => {
  const response = await apiClient.postHttp(
    `${THEME_TEMPLATE_API_REMOVE}`,
    removedModel
  );
  return response;
};

export const getThemeTemplateById = async (id: string) => {
  return await apiClient.getHttp<ThemeTemplateModel>(
    `${THEME_TEMPLATE_API}/${id}`
  );
};

export const getThemeTemplateList = async () => {
  return await apiClient.getHttp<ThemeTemplateModel[]>(`${THEME_TEMPLATE_API}`);
};

export const addThemeTemplate = async (model: ThemeTemplateModel) => {
  const response = await apiClient.postHttp<string>(
    `${THEME_TEMPLATE_API}`,
    model
  );
  return response;
};

export const updateThemeTemplate = async (model: ThemeTemplateModel) => {
  const response = await apiClient.putHttp(`${THEME_TEMPLATE_API}`, model);
  return response;
};
